// Redux
import thunkMiddleware from 'redux-thunk'
import { createStore, combineReducers, applyMiddleware, compose } from 'redux'

// Reducers
import appStateReducer from '../reducers/appStateReducer'
import authenticationReducer from '../reducers/authenticationReducer'
import itemReducer from '../reducers/itemReducer'
import itemsReducer from '../reducers/itemsReducer'
import templatesReducer from '../reducers/templatesReducer'
import userReducer from '../reducers/userReducer'
import variablesReducer from '../reducers/variablesReducer'

const reducer = combineReducers({
  app: appStateReducer,
  auth: authenticationReducer,
  templates: templatesReducer,
  item: itemReducer,
  items: itemsReducer,
  user: userReducer,
  variables: variablesReducer
})

const store = createStore(
  reducer, compose(
    applyMiddleware(
      thunkMiddleware
    ),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  )
)

export default store



// WEBPACK FOOTER //
// /app/js/stores/store.js